import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { store, injectReducer, sagaMiddleware } from '../helpers/store';

import sagas from './sagas';
import { locations, ui, checkout, profile, owner, partner } from '../redux/slices';

const ownerPersistConfig = {
  key: 'owner',
  storage,
  whitelist: ['shownOrionModal'], // or any keys you want to persist
};

const persistedOwner = persistReducer(ownerPersistConfig, owner);

injectReducer('locations', locations);
injectReducer('ui', ui);
injectReducer('checkout', checkout);
injectReducer('profile', profile);
injectReducer('owner', persistedOwner);
injectReducer('partner', partner);

sagaMiddleware.run(sagas);

export { store };
